import type { ReactNode } from 'react';
import { cn } from 'lib/utils';
import { TONE_CLASSES } from 'components/admin/audit/pillTone';

const DOTS = { sky: 'bg-sky-500', amber: 'bg-amber-500' };

/** 5.5: page banner — sky (job running elsewhere) or amber (stale, partial), with an optional inline action. */
const Banner = ({ tone, children, action }: { tone: keyof typeof DOTS; children: ReactNode; action?: ReactNode }) => (
  <div role="status" className={cn('flex flex-wrap items-center gap-2.5 rounded-[10px] px-3.5 py-2.5 text-[13px] font-medium', TONE_CLASSES[tone])}>
    <span className={cn('h-2 w-2 shrink-0 rounded-full', DOTS[tone])} aria-hidden="true" />
    <span className="flex-1">{children}</span>
    {action}
  </div>
);

export default Banner;
